import JwtService from './jwtService'

export default function useJwt(axios, jwtOverrideConfig) {
  const jwt = new JwtService(axios, jwtOverrideConfig)

  return {
    jwt,
  }
}
